var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoChevronDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.18651 4.28125C1.06216 4.40625 0.999994 4.59375 0.999994 4.84375C0.999994 5.09375 1.06216 5.28125 1.18651 5.40625C6.59587 10.3438 9.3316 12.8438 9.39378 12.9063C9.51813 13.0313 9.70465 13.0938 9.95336 13.0938C10.2021 13.0938 10.3886 13.0313 10.5129 12.9063L18.7202 5.40625C19.0933 5.03125 19.0933 4.65625 18.7202 4.28125C18.3471 3.90625 17.9741 3.90625 17.601 4.28125L10.6995 10.5625C10.6995 10.5625 10.1898 11.0938 9.95336 11.0938C9.71693 11.0938 9.20725 10.5625 9.20725 10.5625L2.30568 4.28125C1.93263 3.90625 1.55957 3.90625 1.18651 4.28125Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoChevronDown);
export default __webpack_public_path__ + "static/media/ico_chevron_down.d5edd0f6bb566d7dc4839ff530e84caf.svg";
export { ForwardRef as ReactComponent };